(function() {

	angular
		.module('ngmvac')
		.filter('priceFilter', PriceFilter);

	function PriceFilter() {
		return function(arr, min, max) {
			arrAux = [];

			angular.forEach(arr, function(hotel) {

				var clHotel = {};
				for( property in hotel ) {
					clHotel[property] = hotel[property];
				}
				clHotel.packageGrouped = [];

				angular.forEach(hotel.packageGrouped, function(group) {
					clHotel.packageGrouped.push([]);
					angular.forEach(group, function(pack) {
						if( pack.price >= min && pack.price <= max ) {
							clHotel.packageGrouped[clHotel.packageGrouped.length - 1].push(pack);
						}
					});

					if( clHotel.packageGrouped[clHotel.packageGrouped.length - 1].length == 0 ) {
						clHotel.packageGrouped.splice(clHotel.packageGrouped.length - 1, 1);
					}
				});

				if( clHotel.packageGrouped.length > 0 ) {
					arrAux.push(clHotel);
				}
			});

			return arrAux; 
		}
	}

})();